import React from "react";
import ContactCard from "../../ContactCard";
import { Modal } from "reactstrap";
import "./styles.scss";
import _find from "lodash/find";
import { PUBLIC, MY_CONTACTS } from "../../../utils/profilePrivacy";

class ProfileCardModal extends React.Component {
  render() {
    const {
      profile,
      isOpen,
      onToggle,
      loggedInUser,
      onAdd,
      onRemove,
      isUserLoggedIn,
    } = this.props;

    const isContact = (profileId, contacts) => {
      if (this.props.contacts) {
        return _find(contacts, contact => contact.id === profileId);
      }
      return false;
    }

    const _allowedToViewContacts = () => {
      if(!profile || loggedInUser.id === profile.id) {
        return true;
      }

      const _isContact = isContact(profile.id, loggedInUser.contacts);
      const contactsPrivacy = profile.privacy;

      switch (contactsPrivacy) {
        case PUBLIC:
          return true;
        case MY_CONTACTS:
          return _isContact;
        default:
          return false;
      }
    }

    return (
      <React.Fragment>
        <Modal
          isOpen={isOpen}
          toggle={onToggle}
          id="profile-card-modal"
          className={`${this.props.className} no-min-height contact-card-modal`}
          size="lg"
        >
          {profile && (
            <ContactCard
              key={profile.id}
              hasContacts={profile.contacts && profile.contacts.length > 0}
              profile={profile}
              showShare={false}
              showAdd={true}
              showEdit={false}
              showContacts={true}
              loggedInUser={loggedInUser}
              onAdd={onAdd}
              onRemove={onRemove}
              isUserLoggedIn={isUserLoggedIn}
              contacts={loggedInUser.id === profile.id ? loggedInUser.contacts : profile.contacts}
              showContactAction={loggedInUser.id === profile.id}
              allowedToViewContacts={_allowedToViewContacts()}
            />
          )}
        </Modal>
      </React.Fragment>
    );
  }
}

export default ProfileCardModal;



// WEBPACK FOOTER //
// ./src/components/modals/ProfileCardModal/ProfileCardModal.jsx